import EntityGrid from './EntityGrid';

export default EntityGrid;
